import styled from "styled-components";

const StyledSelectedColorCard = styled.div`
	background-color: ${(props) => (props.selectedColor ? props.selectedColor : props.theme.colors.black)};
	width: 150px;
	height: 50px;
	display: flex;
	align-items: center;
	justify-content: center;
	border-radius: 10px;

	p {
		text-shadow: 1px 1px black;
		font-size: 16px;
		font-weight: 700;
	}
`;

export default StyledSelectedColorCard;

